import { AutogenModelCarrierSalesProfile, AutogenRowCarrierSalesProfile } from "./autogen/AutogenModelCarrierSalesProfile";

export class ModelCarrierSalesProfile extends AutogenModelCarrierSalesProfile<RowCarrierSalesProfile> {
	constructor() {
		super(RowCarrierSalesProfile);
	}
}

export class RowCarrierSalesProfile extends AutogenRowCarrierSalesProfile {
}